<template>
  <div>
    <div class="header">
      <div>
        <div class="name" v-if="userInfo.roleId == 3">
          {{ userInfo.schoolName }}
          <div class="m8">课后服务管理平台</div>
          <div class="version">基础版</div>
        </div>
        <div class="name" v-if="userInfo.roleId == 4">
          {{ userInfo.institutionName }}
        </div>
      </div>
      <div class="operation">
        <!-- <div class="mr20" v-if="userInfo.roleId == 3">
        <a><img src="../../public/home/migoAI.png" alt=""></a>
      </div> -->
        <!-- 今日 -->
        <CPopover @hide-popover="hidePopover" v-if="userInfo.roleId == 3">
          <template slot="content">
            <div class="today">
              <div class="date">
                {{ currentDay }} 星期{{ weekday }}
              </div>
              <div class="total">
                <div class="flex1">
                  <div class="pic">
                    <img src="/index/icon10.png" />
                  </div>
                  <div class="number">
                    {{ classData.totalClassCount || 0 }}
                    <p>开课班级</p>
                  </div>
                </div>
                <div class="flex1">
                  <div class="pic">
                    <img src="/index/icon4.png" />
                  </div>
                  <div class="number">
                    {{ studentData.totalStudent || 0 }}
                    <p>应出勤学生</p>
                  </div>
                </div>
              </div>
              <div class="jcsb">
                <div class="detail">
                  <div class="logo1">
                    <img src="/index/icon5.png" />
                  </div>
                  <div class="label"><b>作业托管</b></div>
                  <div class="count">{{ classData.trustClassCount || 0 }}</div>
                  <div>开课班级</div>
                  <div class="count">{{ studentData.trustStudentCount || 0 }}</div>
                  <div>参与学员</div>
                </div>
                <div class="detail m16">
                  <div class="logo1">
                    <img src="/index/icon6.png" />
                  </div>
                  <div class="label"><b>学校社团</b></div>
                  <div class="count">{{ classData.corClassCount || 0 }}</div>
                  <div>开课班级</div>
                  <div class="count">{{ studentData.corStudentCount || 0 }}</div>
                  <div>参与学员</div>
                </div>
                <div class="detail">
                  <div class="logo1">
                    <img src="/index/icon7.png" />
                  </div>
                  <div class="label"><b>特色课程</b></div>
                  <div class="count">{{ classData.perClassCount || 0 }}</div>
                  <div>开课班级</div>
                  <div class="count">{{ studentData.perStudentCount || 0 }}</div>
                  <div>参与学员</div>
                </div>
              </div>
              <div class="detail-btn">
                <a-button @click="goTodayDetail">查看更多详情<a-icon type="right-circle" /></a-button>
              </div>
            </div>
          </template>
          <a-button type="link" @mouseenter="chooseTab(1)" :class="{ 'actived': active == 1 }">今日</a-button>
        </CPopover>
        <!-- 学校服务群 -->
        <CPopover @hide-popover="hidePopover" v-if="userInfo.roleId == 3 && groupSetting == 1">
          <template slot="content">
            <div v-if="groupBind && schoolQrCode" class="qrCode">
              <img :src="schoolQrCode">
            </div>
            <div v-else class="no-qrCode">
              <div class="describe">
                <p>通过5步操作，创建学校沟通群</p>
                <p>请按如下提示操作</p>
              </div>
              <div class="step">
                <div class="line"></div>
                <div class="step-head">
                  <div class="round">1</div>
                  <div class="title">加入企业微信</div>
                </div>
                <div class="tip">*仅第一次建群需要操作，后续建班请跳过</div>
                <div class="step-body">
                  <p>请保存下方二维码，使用企业微信App扫码加入企业微信，<span class="c-blue">暂时只支持米果官方企业微信。</span></p>
                  <p>申请后请耐心等待通过，如已加入请跳过此步。</p>
                  <div class="qrcode">
                    <img :src="qyQrCode">
                  </div>
                  <div class="save-btn">
                    <a :href="rootUrl + qyQrCode" :download="rootUrl + qyQrCode" target="_blank">
                      <a-button class="btn-h">保存图片</a-button>
                    </a>
                  </div>
                </div>
              </div>
              <div class="step">
                <div class="line"></div>
                <div class="step-head">
                  <div class="round">2</div>
                  <div class="title">添加个人微信至通讯录</div>
                </div>
                <div class="tip">*仅第一次建群需要操作，后续建班请跳过</div>
                <div class="step-body">
                  <p>在企业微信中，点击右上角<span class="c-blue">“+”</span>按钮，选择<span class="c-blue">“添加客户”</span>，进入下一个页面。</p>
                  <div class="pic">
                    <img src="https://static.khsdb.com/oper/step1.png">
                  </div>
                  <p>在添加客户界面中，选择<span class="c-blue">“将名片分享到微信”</span>，并发至本人私人微信，以便后续创建外部群。</p>
                  <div class="pic">
                    <img src="https://static.khsdb.com/oper/step2.png">
                  </div>
                  <p>切换至个人微信中，并点击名片并通过申请。</p>
                  <p style="margin-bottom: 24px;">如已添加过个人微信，请跳过此步。</p>
                </div>
              </div>
              <div class="step">
                <div class="line"></div>
                <div class="step-head">
                  <div class="round">3</div>
                  <div class="title">创建群聊</div>
                </div>
                <div class="step-body">
                  <p>在企业微信中，点击右上角<span class="c-blue">“+”</span>按钮，选择<span class="c-blue">“发起群聊”</span>，进入下一个页面。</p>
                  <div class="pic">
                    <img src="https://static.khsdb.com/oper/step3.png">
                  </div>
                  <p>在选择联系人界面中，分别选择：“我的客户”中的<span class="c-blue">本人个人微信</span>，“企业通讯录”中的<span
                      class="c-blue">“课后服务AI助理”</span>创建群聊。</p>
                  <div class="pic">
                    <img src="https://static.khsdb.com/oper/step4.png">
                  </div>
                </div>
              </div>
              <div class="step">
                <div class="line"></div>
                <div class="step-head">
                  <div class="round">4</div>
                  <div class="title">修改群名称</div>
                </div>
                <div class="step-body">
                  <p>请修改群名称，群名称如下，请复制后修改：</p>
                  <div class="group-name">
                    <div>{{ userInfo.schoolName }}(S{{ userInfo.schoolId }})</div>
                    <div class="mt8"><a-button @click="copy" class="btn-h">复制群名称</a-button></div>
                    <input type="text" ref="urlInput" :value="copyText" style="position: absolute; left: -9999px;">
                  </div>
                  <div class="pic">
                    <img src="https://static.khsdb.com/oper/step5.png">
                  </div>
                </div>
              </div>
              <div class="step" style="padding-bottom: 46px;">
                <div class="line" style="height: 0;"></div>
                <div class="step-head">
                  <div class="round">5</div>
                  <div class="title">后续设置</div>
                </div>
                <div class="step-body">
                  <p>请耐心等待AI助手协助自动绑定。</p>
                  <p>您可在企业微信App中对应的群聊中，打开下部菜单的“课后助手”，查看绑定信息，或执行其他操作。</p>
                  <div class="pic">
                    <img src="https://static.khsdb.com/oper/step6.png">
                  </div>
                </div>
              </div>
            </div>
          </template>
          <a-button type="link" @mouseenter="chooseTab(5)" :class="{ 'actived': active == 5 }">学校服务群</a-button>
        </CPopover>
        <!-- 待办 -->
        <!-- <CPopover @hide-popover="hidePopover" v-if="userInfo.roleId == 3">
        <template slot="content">
          <div class="todo">
            <div class="count">
              待办
              <span>共计5项</span>
            </div>
            <div class="todo-list">
              <a class="todo-item">
                <div class="text"><span class="dot"></span>新学期需要进行一年级与七年级的新生录入</div>
                <a-icon type="right" />
              </a>
              <a class="todo-item">
                <div class="text"><span class="dot"></span>新学期需要进行一年级与七年级的新生录入</div>
                <a-icon type="right" />
              </a>
              <a class="todo-item">
                <div class="text"><span class="dot"></span>新学期需要进行一年级与七年级的新生录入</div>
                <a-icon type="right" />
              </a>
              <a class="todo-item">
                <div class="text"><span class="dot"></span>新学期需要进行一年级与七年级的新生录入</div>
                <a-icon type="right" />
              </a>
            </div>
            <div class="clear">
              <a-button type="link"><a-icon type="delete" />删除已读</a-button>
            </div>
          </div>
        </template>
        <a-button type="link" @mouseenter="chooseTab(2)" :class="{ 'actived': active == 2 }">待办
          <span v-if="!true">（2）</span>
        </a-button>
      </CPopover> -->
        <!-- 运营小程序 -->
        <CPopover @hide-popover="hidePopover" v-if="userInfo.roleId == 3">
          <template slot="content">
            <div class="mini">
              <img src="../../public/portal/mini program.png" alt="">
            </div>
          </template>
          <a-button type="link" @mouseenter="chooseTab(3)" :class="{ 'actived': active == 3 }">运营小程序</a-button>
        </CPopover>
        <!-- 在线客服 -->
        <!-- <CPopover @hide-popover="hidePopover" v-if="userInfo.roleId == 3">
        <template slot="content">
          <div class="service">
            <img src="../../public/home/wxservice.png" alt="">
          </div>
          <div class="qr-text">扫描上方二维码在线咨询</div>
        </template>
        <a-button type="link" @mouseenter="chooseTab(4)" :class="{ 'actived': active == 4 }">在线客服</a-button>
      </CPopover> -->
        <div style="width: 10px;"></div>
        <CPopover @hide-popover="hidePopover" :contentWidth="contentWidth" ref="popoverRef">
          <template slot="content">
            <p v-if="userInfo.roleId == 3"><a-button type="link" class="oper-box"
                :style="{ width: contentWidth + 'px' }" @click="goSchoolInfo">学校信息</a-button></p>
            <p><a-button type="link" class="oper-box" :style="{ width: contentWidth + 'px' }"
                @click="goUserInfo">账号信息</a-button></p>
            <p><a-button type="link" class="oper-box" :style="{ width: contentWidth + 'px' }" @click="changeSchool"
                v-if="schoolList.length">切换学校</a-button></p>
            <p><a-button type="link" class="oper-box" :style="{ width: contentWidth + 'px' }"
                @click="logout">退出登录</a-button>
            </p>
          </template>
          <a :href="url" target="_blank" title="以当前登录身份新开窗口" rel="opener">
            <div class="user">
              <div class="pic" v-if="userInfo.imgUrl">
                <img :src="userInfo.imgUrl" />
              </div>
              <div class="round" v-else>{{ firstName }}</div>
              <div class="user-name" ref="nameRef">{{ userInfo.username }}</div>
            </div>
          </a>
        </CPopover>

      </div>
    </div>
    <!-- 中心校切换学校 -->
    <center-school-modal ref="centerSchool" :schoolList="schoolList"></center-school-modal>
  </div>
</template>

<script>
import CenterSchoolModal from '/src/views/user/CenterSchoolModal.vue'
import CPopover from '../components/CPopover/CPopover.vue';
import user from '/src/api/user'
import synopsis from '../api/synopsis.js'
import dayjs from 'dayjs';
import Vue from 'vue'
export default {
  data() {
    return {
      active: 0,
      contentWidth: 28,
      userInfo: {},
      firstName: '',
      classData: {},
      studentData: {},
      currentDay: '',
      weekday: '',
      schoolList: [],
      url: '',
      qyQrCode: 'https://static.khsdb.com/oper/qiyemigo.png',
      copyText: '',
      rootUrl: '',
      groupSetting: '',
      groupBind: false,
      schoolQrCode: '',
    }
  },
  components: { CPopover, CenterSchoolModal },
  created() {
    this.$store.dispatch('getUserInfo').then((res) => {
      this.userInfo = res
      if (!res.imgUrl) {
        this.firstName = this.userInfo.username.substr(0, 1)
      }
      this.$nextTick(() => {
        this.contentWidth += this.$refs.nameRef.clientWidth
      })
      if (res.roleId == 3) this.getData()
    })
    this.getSchoolList()
    this.getHostUrl();
    this.getSchoolServiceGroup()
  },
  mounted() {
    this.url = window.location.href
  },
  methods: {
    getHostUrl() {
      this.rootUrl = globalConfig.rootUrl + "/api/pcWeb/aliyun/getFile?url=";
    },
    getSchoolList() {
      if (Vue.ls.get('headerSchoolList')) {
        let data = Vue.ls.get('headerSchoolList')
        this.schoolList = data == 'NON' ? [] : data
      } else {
        let requestFun = user.getSchoolList
        requestFun().then((res) => {
          Vue.ls.set('headerSchoolList', res.data)
          this.schoolList = res.data == 'NON' ? [] : res.data
        })
      }
    },
    getData() {
      this.currentDay = dayjs(new Date()).format('YYYY-MM-DD')
      this.weekday = dayjs(new Date()).format('d') == 1 ? '一' : dayjs(new Date()).format('d') == 2 ? '二' : dayjs(new Date()).format('d') == 3 ? '三' : dayjs(new Date()).format('d') == 4 ? '四' : dayjs(new Date()).format('d') == 5 ? '五' : dayjs(new Date()).format('d') == 6 ? '六' : '日'
      if (Vue.ls.get('todayData')) {
        let data = Vue.ls.get('todayData')
        this.classData = data.scheduleOperClassCountDTO ? data.scheduleOperClassCountDTO : {}
        this.studentData = data.scheduleOperStudentCountDTO ? data.scheduleOperStudentCountDTO : {}
      } else {
        synopsis.getTodayData(this.currentDay).then(res => {
          Vue.ls.set('todayData', res.data)
          this.classData = res.data.scheduleOperClassCountDTO ? res.data.scheduleOperClassCountDTO : {}
          this.studentData = res.data.scheduleOperStudentCountDTO ? res.data.scheduleOperStudentCountDTO : {}
        })
      }
    },
    chooseTab(num) {
      this.active = num
    },
    hidePopover() {
      this.active = 0
    },
    goSchoolInfo() {
      this.$router.push({ name: 'schoolInfo' })
    },
    goUserInfo() {
      this.$router.push({ name: 'userCenter' })
    },
    goTodayDetail() {
      this.$router.push({ name: 'today' })
    },
    changeSchool() {
      this.$refs.centerSchool.init()
      this.$refs.popoverRef.hidePopover()
    },
    async copy() {
      let text = this.userInfo.schoolName + "(S" + this.userInfo.schoolId + ")"
      this.copyText = text;
      try {
        // 优先使用现代Clipboard API
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
          this.$message.success('已复制到剪贴板');
        } else {
          // 兼容旧浏览器的回退方案
          this.fallbackCopy();
        }
      } catch (err) {
        // 如果Clipboard API失败，使用回退方案
        this.fallbackCopy();
      }
    },
    fallbackCopy() {
      const input = this.$refs.urlInput;
      input.select();
      input.setSelectionRange(0, 99999); // 对于移动设备很重要
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message.success('已复制到剪贴板');
        } else {
          this.$message.success('复制失败');
        }
      } catch (err) {
        this.$message.success('复制失败');
      }
      // 有些设备会自动弹出键盘，需要手动失焦
      input.blur();
    },
    getSchoolServiceGroup() {
      let _this = this;
      let data = Vue.ls.get('schoolChatInfo')
      if (data) {
        this.groupSetting = data.enableGroupSetting
        this.groupBind = data.ifBindSchool
        this.schoolQrCode = data.chatQrcode
      } else {
        synopsis.getSchoolChatInfo().then(res => {
          data = res.data
        }).catch(() => {
          data = {
              enableGroupSetting: 0,
              ifBindSchool: false,
              chatQrcode: ''
            }
         }).finally(() => {
            Vue.ls.set('schoolChatInfo', data)
            console.log('学校服务群配置信息----------', data)
            _this.groupSetting = data.enableGroupSetting
            _this.groupBind = data.ifBindSchool
            _this.schoolQrCode = data.chatQrcode
         })
      }
    },
    logout() {
      this.$refs.popoverRef.hidePopover()
      let self = this
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        cancelText: '取消',
        okText: '确定',
        onOk() {
          user.logout()
          //退出时给菜单页权限页面给清除掉
          let routerList = self.$router.options.routes
          if (routerList[0] && routerList[0].children) {
            routerList[0].children = []
          }
          self.clearCookie()

          self.$router.selfaddRoutes(routerList)
          self.$router.push('login')
          //清除缓存
          self.$store.commit('CLEARLOGIN')
          window.menuList = null
        },
      })
    },
    // 清除cookie
    clearCookie() {
      // let requestFun = ;
      user.exit().then((res) => { })
    },
  },
}
</script>

<style scoped lang="less">
.header {
  font-family: Source Han Sans;
  height: 68px;
  border-bottom: 1px solid #EAEAEA;
  display: flex;
  justify-content: space-between;
  padding: 0 63px 0 38px;
  align-items: center;

  .name {
    display: flex;
    min-width: 400px;
    align-items: center;
    font-size: 24px;
    font-weight: bold;
    color: #3D3D3D;
    height: 32px;

    .m8 {
      margin: 0 8px;
      min-width: 208px;
    }

    .version {
      min-width: 80px;
      background: linear-gradient(253deg, #64B9FF 1%, #249CFF 98%);
      padding: 3px 13px;
      font-size: 18px;
      text-align: center;
      border-radius: 8px;
      height: 32px;
      margin-right: 20px;
      color: #fff;
      font-weight: normal;
    }
  }

  .operation {
    float: right;
    display: flex;
    align-items: center;
    font-size: 18px;

    .mr20 {
      margin-right: 20px;
    }

    .ml10 {
      margin-left: 10px;
      font-size: 18px;
      color: #181920;
    }

    button {
      padding: 0 20px;
      font-size: 18px;
      color: #747579;
    }

    .actived {
      font-weight: bold;
      color: #181920;
    }

    .qr-code {
      text-align: center;
      margin: 52px 48px 30px;
    }

    .user {
      display: flex;
      align-items: center;

      .pic {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        margin-right: 10px;

        img {
          width: 38px;
          height: 38px;
          border-radius: 50%;
        }
      }

      .round {
        background-color: #a7e5cb;
        min-width: 38px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        font-size: 18px;
        color: #fff;
        font-weight: bold;
        border-radius: 50%;
        margin-right: 10px;
      }
    }

    .service {
      padding: 42px 56px 20px;
    }

    .qr-text {
      font-size: 18px;
      text-align: center;
      margin-bottom: 10px;
      color: #747579;
    }
  }

  .oper-box {
    text-align: center;
    height: 40px;
    font-size: 14px !important;
    color: #181920 !important;
  }

  .oper-box:hover {
    background-color: #eaf6ff;
    border-radius: 8px;
  }
}

.today {
  padding: 14px 14px 10px;

  .date {
    min-width: 488px;
    border-radius: 8px;
    padding: 15px 24px;
    font-size: 24px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 16px;
    background: linear-gradient(88deg, #3198FF 10%, #31D2FF 99%);
  }

  .total {
    display: flex;
    border: 1px solid #F2F2F2;
    border-radius: 8px;
    padding: 24px;
    min-width: 410px;
    margin-bottom: 18px;
    color: #181920;

    .number {
      font-size: 32px;
      font-weight: bold;

      p {
        font-weight: normal;
        font-size: 14px;
      }
    }

    .pic {
      width: 70px;
      height: 70px;
      margin-right: 24px;
    }
  }

  .flex1 {
    display: flex;
    flex: 1;
  }

  .jcsb {
    display: flex;
    justify-content: space-between;
  }

  .detail {
    flex: 1;
    padding: 20px;
    border-radius: 8px;
    border: 1px solid #F0F2F5;
    font-size: 14px;

    .logo1 {
      width: 32px;
      height: 32px;
    }

    .label {
      margin: 10px 0 12px;
    }

    .count {
      font-size: 20px;
      line-height: 22px;
      margin: 12px 0 5px;
      font-weight: bold;
    }
  }

  .m16 {
    margin: 0 16px;
  }

  .detail-btn {
    margin-top: 24px;
    text-align: center;

    button {
      font-size: 14px;
      width: 151px;
      height: 40px;
      line-height: 40px;
      color: #249cff;
      border-color: #249cff;
    }
  }
}

.qrCode {
  padding: 5px;

  img {
    width: 230px;
    height: 230px;
    object-fit: cover;
  }
}

.no-qrCode {
  padding: 10px;
  height: 75vh;
  overflow: auto;

  .describe {
    padding: 16px;
    margin-bottom: 16px;
    background-color: #ebf8ff;
    color: #3D3D3D;
    font-size: 16px;
    font-weight: 700;
  }

  .step {
    padding: 0 25px 14px 16px;
    position: relative;

    .line {
      position: absolute;
      top: 35px;
      left: 33px;
      width: 1px;
      height: 100%;
      background-color: #B7DEFF;
      z-index: 1;
    }

    .line::before {
      content: '';
      position: absolute;
      left: -12px;
      top: -5px;
      width: 0;
      height: 0;
      border-top: 15px solid #0089ff;
      border-left: 13px solid transparent;
      border-right: 13px solid transparent;
      border-bottom: 0 solid transparent;
    }

    .step-head {
      display: flex;
      align-items: center;

      .round {
        width: 36px;
        height: 36px;
        line-height: 28px;
        text-align: center;
        border-radius: 50%;
        border: 4px solid #0089FF;
        color: #0089FF;
        font-size: 18px;
        margin-right: 16px;
        background-color: #fff;
        z-index: 2;
      }

      .title {
        font-weight: 16px;
        color: #0089FF;
        font-weight: bold;
      }

    }

    .tip {
      font-size: 12px;
      margin-left: 52px;
      color: #FF8400;
      margin-bottom: 12px;
    }

    .step-body {
      padding-left: 52px;

      p {
        font-size: 14px;
      }

      .qrcode {
        margin: 10px 0 20px;
        padding: 10px;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.06);
        border-radius: 10px;
        width: 240px;

        img {
          width: 220px;
          height: 220px;
        }
      }

      .pic {
        margin: 24px 0;
        width: 300px;

        img {
          border-radius: 10px;
          width: 100%;
          object-fit: cover;
        }
      }

      .save-btn {
        margin-bottom: 12px;

        button {
          width: 240px;
        }
      }

      .group-name {
        margin: 8px 0 17px;
        padding: 20px 20px 16px;
        background-color: #ebf8ff;
        border-radius: 10px;
        text-align: center;
        color: #3D3D3D;
        font-size: 16px;
        font-weight: bold;

        .mt8 {
          margin-top: 8px;
        }
      }
    }
  }
}

.btn-h:hover {
  color: #40a9ff !important;
}

.todo {
  padding: 10px 10px 4px;
  min-width: 500px;
  font-size: 14px;

  .count {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 24px;
    border-radius: 8px;
    font-size: 24px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 16px;
    background: linear-gradient(86deg, #FF9531 10%, #FFB331 99%);

    span {
      font-size: 14px;
      font-weight: normal;
    }
  }

  .todo-list {
    padding-bottom: 15px;

    .todo-item {
      margin-top: 8px;
      border-radius: 8px;
      border: 1px solid #F2F2F2;
      color: #181920;
      padding: 11px 16px 11px 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .text {
        display: flex;
        align-items: center;
      }

      .dot {
        display: inline-block;
        width: 9px;
        height: 9px;
        border-radius: 60%;
        margin-right: 16px;
        background: #FF9431;
      }

      .readed {
        background: #E7E7E7;
      }

      .anticon {
        color: #808080;
      }
    }
  }

  .clear {
    position: relative;
    margin-top: 14px;
    text-align: center;

    button {
      font-size: 14px;
      height: 20px;
    }

    button:hover {
      color: #249cff;
    }
  }

  .clear::before {
    content: '';
    position: absolute;
    top: -14px;
    left: -20px;
    height: 1px;
    width: calc(100% + 40px);
    background-color: #f2f2f2;
  }
}

.mini {
  padding: 20px;

  img {
    width: 200px;
    height: 200px;
  }
}

// 有待办、客服的时候1440
// @media screen and (max-width: 1440px) {
//   .header {
//     height: calc(68px / 0.8);
//     zoom: 0.8;
//   }
// }
.user-name {
  color: #181920;
  max-height: 54px;
  min-width: 72px;
}
</style>